module.exports = __webpack_public_path__ + "img/Group-10068.f0426e54.svg";